import { createReducer, on } from '@ngrx/store';
import { routes } from '@libs/utils';
import { collaborationsActions } from './collaborations.actions';

export interface CollaborationsState {
  unreadShowcaseCollaborationIds: string[];
  unreadNonShowcaseCollaborationIds: string[];
}

const initialState: CollaborationsState = {
  unreadShowcaseCollaborationIds: [],
  unreadNonShowcaseCollaborationIds: [],
};

export const collaborationsReducer = createReducer(
  initialState,
  on(collaborationsActions.wsInitUnreadCollaborations, (state, { data: { unreadCollaborations } }): CollaborationsState => {
    return {
      ...state,
      unreadShowcaseCollaborationIds: unreadCollaborations
        .filter((collaboration) => collaboration.siteId === routes.showcaseSiteId)
        .map((collaboration) => collaboration.collaborationId),
      unreadNonShowcaseCollaborationIds: unreadCollaborations
        .filter((collaboration) => collaboration.siteId !== routes.showcaseSiteId)
        .map((collaboration) => collaboration.collaborationId),
    };
  }),
  on(collaborationsActions.wsReadCollaboration, (state, { data: { collaborationId, siteId } }): CollaborationsState => {
    const showcaseCollab = siteId === routes.showcaseSiteId;

    return {
      ...state,
      unreadShowcaseCollaborationIds: showcaseCollab
        ? state.unreadShowcaseCollaborationIds.filter((id) => id !== collaborationId)
        : state.unreadShowcaseCollaborationIds,
      unreadNonShowcaseCollaborationIds: showcaseCollab
        ? state.unreadNonShowcaseCollaborationIds
        : state.unreadNonShowcaseCollaborationIds.filter((id) => id !== collaborationId),
    };
  }),
  on(collaborationsActions.collaborationBecameUnread, (state, { collaborationId, siteId }): CollaborationsState => {
    const showcaseCollab = siteId === routes.showcaseSiteId;

    return {
      ...state,
      unreadShowcaseCollaborationIds: showcaseCollab
        ? [...state.unreadShowcaseCollaborationIds, collaborationId]
        : state.unreadShowcaseCollaborationIds,
      unreadNonShowcaseCollaborationIds: showcaseCollab
        ? state.unreadNonShowcaseCollaborationIds
        : [...state.unreadNonShowcaseCollaborationIds, collaborationId],
    };
  }),
);
